import { LinksSchemaType } from "../type";

export const intlHotelLinksArray: LinksSchemaType = {
  main: "/international-hotel",
  maintitle: "صفحه اصلی هتل خارجی",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/hotel-int-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/hotel-int-mobile.png`,
  noFollow: true,
  otherlinks: [
    {
      title: "هتل های استانبول",
      href: "/international-hotel/istanbul-tr",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/istanbul.png`
    },
    {
      title: "هتل های وان",
      href: "/international-hotel/van-inland-tr",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/van.png`
    },
    {
      title: "هتل های تفلیس",
      href: "/international-hotel/tiflis-tbilisi-and-surrounding-area-ge",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/teplis.png`
    },
    {
      title: "هتل های مسقط",
      href: "/international-hotel/muscat-oman-om",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/muscat.png`
    },
    {
      title: "هتل های دبی",
      href: "/international-hotel/dubai-dubai-ae",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/dubai.png`
    },
    {
      title: "هتل های شارجه",
      href: "/international-hotel/sharjah-sharjah-and-ajman-ae",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/sharjah.png`
    },
    {
      title: "هتل های ترابزون",
      href: "/international-hotel/trabzon-black-sea-coast-tr",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/trabzon.png`
    },
    {
      title: "هتل های ایروان",
      href: "/international-hotel/yerevan-armenia-am",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/iravan.png`
    },
    {
      title: "هتل های آنکارا",
      href: "/international-hotel/ankara-inland-tr",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/ankara.png`
    }
  ]
};
